export default "__VITE_ASSET__BmG6y5n___"